import { Money } from '../../../../types';

export const isZeroPrice = (money: Money | null | undefined): boolean => money?.amount === 0;
